module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Certificate_Icon.75a29e01.png";